import React from 'react';
import { Modal } from 'antd-mobile';
import Calendar from '../Calendar/Calendar';


export default class DateRangeOnlyModal extends React.Component {


  _dateRangeClick = (startDate, endDate) => {
    this.props.onChange && this.props.onChange(startDate, endDate);
  }

  render() {
    let { visible, onClose, onChange, startDate, endDate, animationType } = this.props;
    return (
      <Modal
        popup
        wrapClassName='dateRangeOnlyModal-modal-wrap'
        visible={visible}
        onClose={onClose}
        animationType={animationType || "slide-down"}>
        <Calendar startDate={startDate} endDate={endDate} dateClick={this._dateRangeClick} />
      </Modal>
    )
  }
}